import axios from '@/plugins/http/axios.js';
import config from "@/views/change_password_security/config/change_pass_security_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);


export const service = {

    postChangePasswordSecurity: ({ idGroup, idEmpresa, idUsuario, changenPassSecurity }) => {
        return axios.post(
          `${config.baseUrl + _pathUri.generateUri() + idGroup}/login/changePassword`,
          {

              userId: idUsuario,
              currentPassword: btoa(changenPassSecurity.currentPassword),
              firstPassword: btoa(changenPassSecurity.password),
              secondPassword: btoa(changenPassSecurity.confirmationPassword),

          },
    
          {
            headers: {
              'Content-Type': 'application/json',
              'idEmpresa': idEmpresa,
              'idUsuario': idUsuario
            }
          }
        )
      },
    

}   